import { RootReducerType } from "../CombineReducer";

export const useGetSiteServiceList = (state: RootReducerType) => state.siteService.serviceList;
export const useGetSiteServiceListLoading = (state: RootReducerType) => state.siteService.isLoading;
